/**
 * Логотип ALLSWIPES.
 *
 * Два начертания: полное (знак + надпись) и короткий знак. Оба приходят из
 * исходника владельца; изменено в них ровно одно — буквы рисуются
 * `currentColor` вместо белого, иначе на светлой теме надпись исчезает.
 * Жёлтый и бирюзовый — фирменные и не зависят от темы.
 */
import type { CSSProperties } from 'react';

const TITLE = 'ALLSWIPES';

/** Полное начертание: знак и надпись. `height` задаёт размер, ширина считается. */
export function Logo({
  height = 20,
  className,
  style,
}: {
  height?: number;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={(height * 189) / 47}
      height={height}
      viewBox="0 0 189 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={TITLE}
      className={className}
      style={style}
    >
      <path
        d="M23.4552 14.281C22.7266 9.50884 28.853 6.92414 31.7629 10.7759C32.3728 11.5832 32.7028 12.5674 32.7028 13.5792V41.2652L31.5272 41.4537C29.4168 41.7921 27.4347 40.3465 27.1121 38.2336L23.4552 14.281Z"
        fill="#FFC300"
      />
      <path
        d="M35.6592 5.26861C35.6592 0.582609 42.0504 -0.79029 43.9749 3.48231C44.2907 4.18361 44.415 4.95601 44.335 5.72101L41.2029 35.6753C40.9061 38.5138 38.5132 40.6695 35.6592 40.6695V5.26861Z"
        fill="#0FAAA0"
      />
      <path
        d="M45.0928 28.32H50.6608C50.7088 30.384 52.2448 31.68 54.9328 31.68C57.6688 31.68 59.1568 30.576 59.1568 28.848C59.1568 27.648 58.5328 26.784 56.4208 26.304L52.1488 25.296C47.8768 24.336 45.8128 22.32 45.8128 18.528C45.8128 13.872 49.7488 11.088 55.2208 11.088C60.5488 11.088 64.1488 14.16 64.1968 18.768H58.6288C58.5808 16.752 57.2368 15.456 54.9808 15.456C52.6768 15.456 51.3328 16.512 51.3328 18.288C51.3328 19.632 52.3888 20.496 54.4048 20.976L58.6768 21.984C62.6608 22.896 64.6768 24.72 64.6768 28.368C64.6768 33.168 60.5968 36.144 54.7408 36.144C48.8368 36.144 45.0928 32.976 45.0928 28.32ZM72.7513 35.52L65.0713 11.808H71.1673L74.2873 21.984C74.8153 23.856 75.2953 25.92 75.7273 28.128C76.1593 25.824 76.5913 24.336 77.3593 21.984L80.6233 11.808H86.5753L89.7433 21.984C90.0313 22.944 90.9913 26.496 91.2793 28.08C91.6633 26.304 92.4313 23.472 92.8633 21.984L96.0313 11.808H102.223L94.0153 35.52H88.5433L85.2793 25.248C84.3193 22.128 83.7913 19.872 83.5993 18.672C83.3593 19.776 82.9273 21.456 81.7273 25.344L78.4633 35.52H72.7513ZM107.737 7.056C105.721 7.056 104.137 5.472 104.137 3.504C104.137 1.536 105.721 0 107.737 0C109.657 0 111.241 1.536 111.241 3.504C111.241 5.472 109.657 7.056 107.737 7.056ZM104.809 35.52V11.808H110.665V35.52H104.809ZM115.755 46.512V11.808H121.179L121.563 15.408C123.003 12.672 126.123 11.088 129.723 11.088C136.395 11.088 140.811 15.936 140.811 23.376C140.811 30.768 136.779 36.144 129.723 36.144C126.171 36.144 123.099 34.752 121.611 32.352V46.512H115.755ZM121.659 23.664C121.659 27.936 124.299 30.864 128.331 30.864C132.459 30.864 134.907 27.888 134.907 23.664C134.907 19.44 132.459 16.416 128.331 16.416C124.299 16.416 121.659 19.392 121.659 23.664ZM155.122 36.144C148.066 36.144 143.122 31.008 143.122 23.664C143.122 16.224 147.97 11.088 154.93 11.088C162.034 11.088 166.546 15.84 166.546 23.232V25.008L148.69 25.056C149.122 29.232 151.33 31.344 155.218 31.344C158.434 31.344 160.546 30.096 161.218 27.84H166.642C165.634 33.024 161.314 36.144 155.122 36.144ZM154.978 15.888C151.522 15.888 149.41 17.76 148.834 21.312H160.738C160.738 18.048 158.482 15.888 154.978 15.888ZM168.449 28.32H174.017C174.065 30.384 175.601 31.68 178.289 31.68C181.025 31.68 182.513 30.576 182.513 28.848C182.513 27.648 181.889 26.784 179.777 26.304L175.505 25.296C171.233 24.336 169.169 22.32 169.169 18.528C169.169 13.872 173.105 11.088 178.577 11.088C183.905 11.088 187.505 14.16 187.553 18.768H181.985C181.937 16.752 180.593 15.456 178.337 15.456C176.033 15.456 174.689 16.512 174.689 18.288C174.689 19.632 175.745 20.496 177.761 20.976L182.033 21.984C186.017 22.896 188.033 24.72 188.033 28.368C188.033 33.168 183.953 36.144 178.097 36.144C172.193 36.144 168.449 32.976 168.449 28.32Z"
        fill="currentColor"
      />
      <path
        d="M8.112 36.1439C3.072 36.1439 0 33.2159 0 28.7519C0 24.3839 3.168 21.6479 8.784 21.2159L15.888 20.6879V20.1599C15.888 16.9439 13.968 15.6479 10.992 15.6479C7.536 15.6479 5.616 17.0879 5.616 19.5839H0.624001C0.624001 14.4479 4.848 11.0879 11.28 11.0879C17.664 11.0879 21.6 14.5439 21.6 21.1199V35.5199H16.464L16.032 32.0159C15.024 34.4639 11.808 36.1439 8.112 36.1439ZM10.032 31.7279C13.632 31.7279 15.936 29.5679 15.936 25.9199V24.6719L10.992 25.0559C7.344 25.3919 5.952 26.5919 5.952 28.5119C5.952 30.6719 7.392 31.7279 10.032 31.7279Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Короткий знак — там, где на надпись нет места: аватар, подвал, вкладка. */
export function LogoMark({
  size = 22,
  className,
  style,
}: {
  size?: number;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={(size * 45) / 41}
      height={size}
      viewBox="0 0 45 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={TITLE}
      className={className}
      style={style}
    >
      <path
        d="M23.4552 13.368C22.7266 8.59576 28.853 6.01106 31.7629 9.86286C32.3728 10.6702 32.7028 11.6544 32.7028 12.6662V40.3522L31.5272 40.5407C29.4168 40.8791 27.4347 39.4335 27.1121 37.3206L23.4552 13.368Z"
        fill="#FFC300"
      />
      <path
        d="M35.6592 4.35552C35.6592 -0.330477 42.0504 -1.70338 43.9749 2.56922C44.2907 3.27052 44.415 4.04292 44.335 4.80792L41.2029 34.7622C40.9061 37.6007 38.5132 39.7564 35.6592 39.7564V4.35552Z"
        fill="#0FAAA0"
      />
      <path
        d="M8.112 35.2308C3.072 35.2308 0 32.3028 0 27.8388C0 23.4708 3.168 20.7348 8.784 20.3028L15.888 19.7748V19.2468C15.888 16.0308 13.968 14.7348 10.992 14.7348C7.536 14.7348 5.616 16.1748 5.616 18.6708H0.624001C0.624001 13.5348 4.848 10.1748 11.28 10.1748C17.664 10.1748 21.6 13.6308 21.6 20.2068V34.6068H16.464L16.032 31.1028C15.024 33.5508 11.808 35.2308 8.112 35.2308ZM10.032 30.8148C13.632 30.8148 15.936 28.6548 15.936 25.0068V23.7588L10.992 24.1428C7.344 24.4788 5.952 25.6788 5.952 27.5988C5.952 29.7588 7.392 30.8148 10.032 30.8148Z"
        fill="currentColor"
      />
    </svg>
  );
}
